import { amountToString } from '@orus.eu/amount'

import type { QuoteModelInput, QuoteModelOutputModel } from '../quote.ts'

import { QuoteV3Calculator } from './quote-calculator.ts'

export function quoteV3ToSerializedQuoteData<
  Key extends keyof QuoteModelInput = keyof QuoteModelInput,
  Model extends QuoteModelInput = QuoteModelInput,
>(quote: QuoteModelOutputModel<Key, Model>): string {
  const quoteCalculator = new QuoteV3Calculator(quote)
  return `Yearly price : ${amountToString(
    quoteCalculator.getYearlyTotalAmountForPaymentRecurrence({
      paymentRecurrence: 'yearly',
      isContractFirstMonth: false,
      isAnnuityFirstMonth: false,
    }),
    {
      addCurrency: true,
      displayDecimals: true,
    },
  )} | Monthly price : ${amountToString(
    quoteCalculator.getMonthlyTotalAmountForPaymentRecurrence({
      paymentRecurrence: 'monthly',
      isContractFirstMonth: false,
      isAnnuityFirstMonth: false,
    }),
    {
      addCurrency: true,
      displayDecimals: true,
    },
  )}`
}
